var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { RebindEvent, RebindEventType } from "./RebindEvent";

var AuthRebindEvent = function (_super) {
  __extends(AuthRebindEvent, _super);

  function AuthRebindEvent(event) {
    var _this = _super.call(this) || this;

    _this.type = RebindEventType.AUTH_EVENT;
    _this.event = event;
    return _this;
  }

  return AuthRebindEvent;
}(RebindEvent);

export default AuthRebindEvent;